import $ from '../common/nano';

class ContactPage {
	constructor() {
		this.initContactForm();
	}

	private initContactForm() {
		import(
				/* webpackChunkName: "ContactForm" */
				'../components/ContactForm'
			)
			.then((module) => {
				const ContactForm = module.default;

				new ContactForm($('.ContactPageMain .ContactForm'));
			});
	}

}

new ContactPage();